module.exports = __webpack_public_path__ + "static/media/go-back-left-arrow.6a018351.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/icons/go-back-left-arrow.svg
// module id = 1628
// module chunks = 0